export const messages = {
  en: {
    seoTitle: "Amir Fahimnia, protecting an artist's name online",
    seoDescription:
      "Names online are easily reused. On protection of a name, domain ownership, and returning control.",

    tagline: "Artist names are fragile online.",
    slogans: [
      "Design your presence.",
      "Keep your name intact.",
      "Precision is protection.",
      "A domain is identity.",
      "Quiet work. Solid results.",
      "A name deserves care.",
      "Every name carries weight."
    ],

    // CONTEXT SECTION

    h2_context: "Context",
    p_context_1: "Over time it becomes clear how easily a name is reused,",
    p_context_1_extra: "copied, or rebuilt somewhere the artist never chose.",

    p_context_1_1:
      "It usually happens quietly, and is often noticed only when it is already too late.",

    p_context_2:
      "For artists working across languages and borders, this happens more often than people expect.",
    p_context_3: "A name carries reputation, memory and trust.",
    p_context_3_extra: "Losing control of it rarely happens all at once.",
    p_context_3_extra_2: "It happens gradually.",

    // PROTECTION SECTION

    h3_protection: "About protecting a name",
    p_protection_1: "Sometimes a name needs immediate care.",
    p_protection_1_extra: "Not strategy. Not branding. Just protection.",
    p_protection_2: "In those moments a domain may be held for a short while,",
    p_protection_2_extra: "to prevent misuse, and nothing more.",
    p_protection_3: "There is no selling here, and no leverage.",

    p_protection_4:
      "As soon as the artist asks for it, the domain is transferred.",

    p_protection_5: "Ownership was never the goal.",
    p_protection_5_extra: "Returning control is.",

    // ABOUT AMIR SECTION

    p_context: "The method matters more than the person.",
    p_context_extra_1: "Still, context helps.",

    intro_prefix_context: "In that context,",
    intro_prefix_name: "I’m Amir Fahimnia",
    intro_prefix_position: "software engineer · designer · lecturer",
    intro_suffix: ".",

    p1: "I work as a software engineer, designer and lecturer.",
    p2_extra_1:
      "This work grew out of years of research and experience, not out of a business plan.",

    // INFO SECTION
    h3_info: "About the primary domain",
    p_info:
      "For many public figures, owning a primary domain such as .com is part of keeping control over their online identity.",
    p_info_1:
      "A dedicated domain lets an artist manage their digital presence independently, and with more stability.",
    p_info_2:
      "I have worked in this space for years, supporting artists along the way, so that the right structure can take shape.",

    // FINAL SECTION

    h3_final: "A simple conversation",
    p_final: "Most conversations begin calmly: with listening,",
    p_final_1_extra:
      "with understanding what exists, and deciding what does not need to be done.",
    p_final_1_extra_2:
      "If you ever think about your name, or about how your work lives online, you are welcome to reach out. Instagram or the email below are available.",

    important_cta:
      "To avoid any misunderstanding: a domain is transferred only after the artist's identity is confirmed.",

    modal_text: "Writing in English works just as well. No forms, no pressure.",
    modal_button: "Send an email",

    footer_city: "Amsterdam, The Netherlands",
    footer_timeOffset: "GMT+1",
    footer_role: "Founder · Lecturer",
    footer_name: "Amir Fahimnia",
    footer_year: "2026",
    footer_version: "V 1.1",

    // BASED SECTION
    based: "Based in The Netherlands"
  },

  fa: {
    seoTitle: "امیر فهیم‌نیا، محافظت از نام هنرمند در اینترنت",
    seoDescription:
      "نام هنرمندان در اینترنت به‌سادگی دوباره به کار گرفته می‌شود. دربارهٔ محافظت از نام، مالکیت دامنه و بازگرداندن کنترل.",

    tagline: "نام هنرمند در اینترنت آسیب‌پذیر است.",
    slogans: [
      "حضور خود را بساز.",
      "نام خود را دست‌نخورده نگه دار.",
      "دقت، محافظت است.",
      "دامنه، هویت است.",
      "کار آرام، نتیجهٔ محکم.",
      "هر نامی سزاوار توجه است.",
      "هر نامی وزن دارد."
    ],

    // CONTEXT SECTION

    h2_context: "زمینه",
    p_context_1:
      "گذشت زمان نشان می‌دهد که استفادهٔ دوباره از یک نام چقدر آسان است.",
    p_context_1_extra:
      "نام تکرار می‌شود، یا در جایی از نو ساخته می‌شود که هنرمند خودش آن را انتخاب نکرده است.",

    p_context_1_1:
      "این اتفاق معمولاً بی‌سروصدا رخ می‌دهد و اغلب تنها زمانی دیده می‌شود که دیگر دیر شده است.",

    p_context_2:
      "برای هنرمندانی که به چند زبان و در چند کشور کار می‌کنند، این اتفاق بیشتر از آنچه انتظار می‌رود رخ می‌دهد.",
    p_context_3: "نام، حامل اعتبار، خاطره و اعتماد است.",
    p_context_3_extra: "از دست دادن کنترل بر آن به‌ندرت یک‌باره رخ می‌دهد.",
    p_context_3_extra_2: "کم‌کم اتفاق می‌افتد.",

    // PROTECTION SECTION

    h3_protection: "دربارهٔ محافظت از یک نام",
    p_protection_1: "گاهی نام یک هنرمند به مراقبت فوری نیاز دارد.",
    p_protection_1_extra: "نه راهبرد، نه برندسازی؛ فقط محافظت.",
    p_protection_2:
      "در چنین موقعیتی، یک دامنه ممکن است برای مدتی کوتاه نگه داشته شود،",
    p_protection_2_extra: "تا از سوءاستفاده جلوگیری شود و بس.",

    p_protection_3: "نه فروشی در کار است، نه اهرم فشار.",

    p_protection_4:
      "به‌محض اینکه خودِ هنرمند درخواست کند، دامنه به او منتقل می‌شود.",

    p_protection_5: "مالکیت هیچ‌گاه هدف نبوده است.",
    p_protection_5_extra: "هدف، بازگرداندن کنترل به خود هنرمند است.",

    // ABOUT AMIR SECTION

    p_context: "روش کار از خودِ آدم مهم‌تر است.",
    p_context_extra_1: "با این حال، دانستن زمینه کمک می‌کند.",

    intro_prefix_context: "در همین زمینه،",
    intro_prefix_name: "من امیر فهیم‌نیا هستم",
    intro_prefix_position: "مهندس نرم‌افزار، طراح و مدرس",
    intro_suffix: ".",

    p1: "من به‌عنوان مهندس نرم‌افزار، طراح و مدرس کار می‌کنم.",
    p2_extra_1: "این کار حاصل سال‌ها پژوهش و تجربه است، نه یک طرح تجاری.",

    // INFO SECTION

    h3_info: "دربارهٔ دامنهٔ اصلی",
    p_info:
      "برای بسیاری از چهره‌های عمومی، داشتن یک دامنهٔ اصلی مانند .com بخشی از حفظ کنترل بر هویت آنلاین است.",
    p_info_1:
      "دامنهٔ اختصاصی به هنرمند این امکان را می‌دهد که حضور دیجیتال خود را مستقل‌تر و با ثبات بیشتری مدیریت کند.",
    p_info_2:
      "سال‌هاست در این حوزه کار می‌کنم و هنرمندان را در این مسیر همراهی می‌کنم تا ساختار درست شکل بگیرد.",

    // FINAL SECTION

    h3_final: "یک گفت‌وگوی ساده",
    p_final: "بیشتر گفت‌وگوها آرام آغاز می‌شوند: با شنیدن،",
    p_final_1_extra:
      "با شناختن آنچه هست، و تصمیم گرفتن دربارهٔ آنچه لازم نیست انجام شود.",
    p_final_1_extra_2:
      "اگر زمانی به نام خود فکر کردید، یا به اینکه کارتان در اینترنت چگونه دیده می‌شود، می‌توانید تماس بگیرید. اینستاگرام یا ایمیل پایین در دسترس است.",

    important_cta:
      "برای جلوگیری از هرگونه سوءتفاهم: انتقال دامنه تنها پس از تأیید هویت هنرمند انجام می‌شود.",

    modal_text:
      "اگر ترجیح می‌دهید فارسی صحبت کنیم، همین‌جا هستم. می‌توانید به فارسی بنویسید؛ بی‌واسطه و بدون عجله.",
    modal_button: "ارسال ایمیل",

    footer_city: "آمستردام، هلند",
    footer_timeOffset: "GMT+1",
    footer_role: "بنیان‌گذار · مدرس",
    footer_name: "امیر فهیم‌نیا",
    footer_year: "۲۰۲۶",
    footer_version: "نسخهٔ ۱.۱",

    // BASED SECTION
    based: "مستقر در هلند"
  }
};
